<div class="mc-tooltip-panel-wrapper"><ng-content></ng-content></div>
